var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.className,attrs:{"id":"his-dev"}},[_c('Title',{attrs:{"ch":"历史沿革","en":"historical development"}}),_c('main',[_c('dev-his'),_c('mana-evo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }